// extracted by css-extract-rspack-plugin
export default {"wrapperSmall":"ProjectRightsGrid_wrapperSmall__tcsaf"};